import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import "./app/styles/index.css"
import { initTelegramApp } from "@/shared/lib/telegram"
import App from "./app"

initTelegramApp()
document.documentElement.classList.add("dark")

createRoot(document.getElementById("root")!).render(
	<StrictMode>
		<App />
	</StrictMode>,
)
